import React from "react";
import OvertimeTable from "./components/OvertimeTable";
import { connect } from "react-redux";
import { ClipboardList, FilePlusCorner } from "lucide-react";
import OvertimeForm from "./components/OvertimeForm";
import PopupButton from "components/button/PopupButton";
import { MODULE_OVERTIME } from "variables/constants";
import SummaryHeader from "components/header/SummaryHeader";

const Overtimes = () => {
    
	return (
	    <div>
			<SummaryHeader
			title="Overtime History"
			icon={ClipboardList}
			description="View your past and pending overtime requests"
			color={"cyan"}
			rightNav={
						<PopupButton 
							id="add_overtime" 
							title="Request Overtime"
							description="Submit a new overtime request"
							label="File Overtime" 
							btnClass="btn-overtime" 
							action="add"
							moduleId={MODULE_OVERTIME}
							icon={FilePlusCorner}
							useCustomClass={true}
						>
							<OvertimeForm recordId="0" mode="edit"/>
						</PopupButton>
			}
		>
		</SummaryHeader>
		<div className="mt-5 grid h-full grid-cols-1 gap-4">      		
			<OvertimeTable />
		</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Overtimes);